import React from "react";
import LoadingSpinner from "./LoadingSpinner";
import { WEEK_1_SCORING_START_LABEL } from "../utils/seasonCalendar";

function CreateLeagueForm({
  newLeagueName,
  setNewLeagueName,
  creatingLeague,
  createError,
  onCreateLeague,
  currentUser,
  unpaidPrivateStatus,
  unpaidPrivateAtCap,
}) {
  if (!currentUser) {
    return null;
  }

  const unpaidLimit = unpaidPrivateStatus?.limit ?? 3;
  const unpaidCount = unpaidPrivateStatus?.count ?? 0;

  return (
    <form onSubmit={onCreateLeague} style={{ marginTop: 24, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      {unpaidPrivateStatus && (
        <div style={{
          background: unpaidPrivateAtCap ? "#fef2f2" : "#f8fafc",
          border: `1px solid ${unpaidPrivateAtCap ? "#fecaca" : "#e2e8f0"}`,
          borderRadius: 6,
          padding: 12,
          marginBottom: 12,
          maxWidth: 340,
          width: "100%",
          fontSize: 13,
          color: unpaidPrivateAtCap ? "#991b1b" : "#475569",
          lineHeight: 1.45,
          boxSizing: "border-box",
        }}>
          {unpaidPrivateAtCap ? (
            <>
              You have {unpaidCount} of {unpaidLimit} unpaid private leagues. Complete payment on an existing league before creating another.
            </>
          ) : (
            <>
              Unpaid private leagues: {unpaidCount} of {unpaidLimit}. Pay the one-time $40 inaugural-season platform fee after creating to activate invites and drafts.
            </>
          )}
        </div>
      )}
      <input
        type="text"
        placeholder="New league name"
        value={newLeagueName}
        onChange={e => setNewLeagueName(e.target.value)}
        maxLength={64}
        style={{ width: "100%", maxWidth: 340, padding: 8, borderRadius: 6, border: "1px solid #b6c3e0", marginBottom: 8, boxSizing: 'border-box' }}
        disabled={creatingLeague}
      />
      <button type="submit" className="ffb-btn" style={{ width: "100%", maxWidth: 340, padding: 10, borderRadius: 6, marginBottom: 8 }} disabled={creatingLeague || unpaidPrivateAtCap}>
        {creatingLeague ? (
          <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}>
            <LoadingSpinner size="small" color="#fff" text="" />
            Creating...
          </span>
        ) : (
          "Create Private League ($40)"
        )}
      </button>
      <div style={{ color: '#64748b', fontSize: 14, marginTop: 6, marginBottom: 2, maxWidth: 340, textAlign: 'center', lineHeight: 1.45 }}>
        One-time $40 inaugural-season platform fee, paid by the commissioner via Stripe after you create the league. League members join free through your email invites.
      </div>
      <div style={{ color: '#2563eb', fontSize: 13, marginTop: 8, marginBottom: 2, maxWidth: 340, textAlign: 'center', lineHeight: 1.45, fontWeight: 600 }}>
        After payment: open your league → League Settings → Manage Invites to email friends a join link.
      </div>
      <div style={{ color: '#92400e', fontSize: 13, marginTop: 8, marginBottom: 2, maxWidth: 340, textAlign: 'center', lineHeight: 1.45 }}>
        Plan to draft before Week 1 scoring begins ({WEEK_1_SCORING_START_LABEL}) for a full season. All leagues follow the same NFL calendar.
      </div>
      {createError && <div style={{ color: 'red', marginTop: 8 }}>{createError}</div>}
    </form>
  );
}

export default CreateLeagueForm;
